var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPadlockSmallinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15.4,
  height: 16.8,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 16.937a2 2 0 1 0-1 0V20h1v-3.063ZM12 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 9V4a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4Zm4-8h2a3 3 0 0 1 3 3v5H8V4a3 3 0 0 1 3-3Zm-8 9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1H3Z",
  fill: "#252829"
})));
export default SvgPadlockSmallinline;